import { createContext } from 'react';

export const InteractiveHeadingContext = createContext();
